import { render, staticRenderFns } from "./FirstScreen.vue?vue&type=template&id=76c1c2f4&scoped=true"
import script from "./FirstScreen.vue?vue&type=script&lang=js"
export * from "./FirstScreen.vue?vue&type=script&lang=js"
import style0 from "./FirstScreen.vue?vue&type=style&index=0&id=76c1c2f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c1c2f4",
  null
  
)

export default component.exports